import { z } from "zod/v4";

import {
  CartTargetingExpressionNodeQuery,
  CartTargetingNode,
  CartTargetingSchema,
} from "../dtos/cart-targeting";

export const CartTargetingFeDisplayDataSchema = z.object({
  title: z.string().optional(),
  image: z.string().optional(),
});

export type CartTargetingFeDisplayDataType = z.infer<
  typeof CartTargetingFeDisplayDataSchema
>;

export const CartTargetingExpressionNodeQueryFeSchema =
  CartTargetingExpressionNodeQuery.extend({
    displayData: z
      .record(z.string(), CartTargetingFeDisplayDataSchema)
      .optional(),
  });

export type CartTargetingExpressionNodeQueryFe = z.infer<
  typeof CartTargetingExpressionNodeQueryFeSchema
>;

export const CartTargetingFeSchema = CartTargetingSchema.extend({
  expression: z.array(
    CartTargetingNode.safeExtend({
      query: CartTargetingExpressionNodeQuery.safeExtend({
        displayData: z
          .record(z.string(), CartTargetingFeDisplayDataSchema)
          .optional(),
      }),
    })
  ),
});

export type CartTargetingFe = z.infer<typeof CartTargetingFeSchema>;
